import type { QueryClient } from '@lumapps/base-api/react-query';
import { queryPredicates } from '@lumapps/widget-base/api';

import { WIDGET_STREAM_TYPE } from '../constants';

/**
 * Invalidates all stream widget queries across the application.
 * Stream widgets include space feeds, personal feeds, and any other feed using the stream widget type.
 * This should be called after creating, updating, or deleting posts, articles, or events
 * to ensure all feeds are refreshed with the latest data.
 */
export const invalidateStreamWidgets = (queryClient: QueryClient): void => {
    queryClient.invalidateQueries({
        predicate: queryPredicates.allWidgetsByWidgetType(WIDGET_STREAM_TYPE),
    });
};
